import { TogglePlan } from '../../secondary/payment-method/payment-method.api';

export const getInitialHash = (plans: TogglePlan[]): Record<number, boolean> =>
  plans.reduce((acc, val) => {
    acc[val.id] = false;
    return acc;
  }, {});

interface MutationProps {
  plansHash: Record<number, boolean>;
  shouldUpdateAllPlans: boolean;
  accountId: number;
  paymentMethodId: number;
  plans: TogglePlan[];
}

// TODO cleanup - delete in favor of MutationVariablesForSetPayment
export interface MutationVariables {
  accountId: number;
  input: {
    paymentMethodId: number;
    planIds: Maybe<number[]>;
  };
}

export const getMutationVariables = ({
  plansHash,
  shouldUpdateAllPlans,
  accountId,
  paymentMethodId,
  plans,
}: MutationProps): MutationVariables | undefined => {
  const planIds = plans
    .filter(plan => !!plansHash[plan.id])
    .map(plan => plan.id);
  const variables = {
    accountId,
    input: { paymentMethodId, planIds: null },
  } as MutationVariables;
  if (shouldUpdateAllPlans) {
    return variables;
  } else if (planIds.length) {
    variables.input.planIds = planIds;
    return variables;
  } else {
    return undefined;
  }
};
